var _style, _symbol, _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse, _ellipse2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBihar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 458,
    height: 548,
    viewBox: "0 0 458 548",
    style: {
      enableBackground: "new 0 0 458 548"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;stroke:#000;stroke-width:5;}\n\t.st1{fill:#fff;}\n\t.st2{fill:#fff;stroke:#000;stroke-width:9;}\n\t.st3{fill:none;stroke:#000;stroke-width:6;}\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "leaf",
    viewBox: "-20.5 -47 41 94.1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-18,0c0-23.9,18-43.4,18-43.4S18-23.9,18,0S0,43.4,0,43.4S-18,23.9-18,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.7,4C0-1.3-4-29.8,0-43.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,4c0,0,0-0.2-0.1-0.5C1.6,3.1,1.4,2.6,1.4,2C1.1,0.7,0.9-1.2,0.7-3.4C0.4-5.6,0.2-8.2,0.1-11 c-0.1-1.4-0.1-2.8-0.2-4.3c-0.1-1.5-0.1-2.9-0.1-4.4c0-1.5,0-3,0-4.4c0.1-1.5,0.1-2.9,0.2-4.3c0.1-1.4,0.2-2.7,0.3-3.9 c0.1-0.6,0.1-1.2,0.2-1.8c0.1-0.6,0.2-1.1,0.3-1.7c0.1-0.5,0.2-1,0.2-1.5c0.1-0.5,0.2-0.9,0.3-1.3c0.2-0.8,0.3-1.6,0.5-2.2 c0.3-1.2,0.5-1.8,0.5-1.8l-4.8-1.4c0,0-0.2,0.8-0.4,2.2C-3-41.2-3-40.4-3.2-39.4c-0.1,0.5-0.1,1-0.2,1.5c0,0.5-0.1,1.1-0.1,1.7 c0,0.6-0.1,1.2-0.1,1.8c0,0.6,0,1.3,0,1.9c0,1.3,0,2.7,0.1,4.1c0,1.4,0.2,2.9,0.3,4.4c0.1,1.5,0.3,3,0.4,4.5 c0.2,1.5,0.3,3,0.5,4.5c0.2,1.5,0.4,2.9,0.6,4.3C-1.2-8-0.7-5.4-0.2-3.2C0.2-1,0.6,0.8,1,2.1c0.2,0.6,0.3,1.1,0.4,1.5 C1.5,3.8,1.6,4,1.6,4L1.7,4z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.7,175.4c-0.3-21.5-15.7,55.9-18.5,67.1c-2.8,11.2-2.8,72-2.8,89.5s3.5,88.8-4.2,103.5 c35,2.8,31.5,0.2,31.5-3.3s-3-100.2-4.7-109.2C227.4,313.9,227.9,193.6,227.7,175.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 428.7,
    className: "st2",
    width: 182,
    height: 105
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 445.2,
    className: "st2",
    width: 153,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2,453.8v55h-46.6v-13.3h-9.6v13.3h-26.5v-28.3h-9.9v28.3h-42.4v-55H295.2z M166,461.6v38.8h30.3v-26.7h14.4v-12.1 h-23.6v28.1l-10.8,0.2v-28.3H166z M230.1,461.6h-10.5v38.8h10.5V461.6z M248.5,461.6h-9.6v27.2h9.6V461.6z M265.8,461.6h-9.4v41.7 h9.4V461.6z M282.7,461.6h-10.1v27.2h10.1V461.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 277.6,
    cy: 500.5,
    rx: 6.8,
    ry: 4.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "93.6,430 93.6,396 80.3,396 80.3,429.9 23,429.9 23,409 57,409 57,396 23.3,396 23.3,338.7  44.2,338.7 44.2,372.7 57,372.7 57,338.7 114.4,338.7 114.4,359.6 80.3,359.6 80.3,372.7 114.5,372.7 114.5,430  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.9,341.2v15.9h-29h-5v5v8.1v5h5H112v52.3H96.1v-29v-5h-5h-8.2h-5v5v28.9H25.5v-15.9h29h5v-5v-7.9v-5h-5H25.8v-52.3 h15.9v29v5h5h7.8h5v-5v-29H111.9 M116.9,336.2H54.5v34h-7.8v-34H20.8v62.3h33.7v7.9h-34v25.9h62.3v-33.9h8.2v34H117v-62.3H82.8 v-8.1h34V336.2L116.9,336.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "412.1,430 412.1,396 398.9,396 398.9,429.9 341.5,429.9 341.5,409 375.5,409 375.5,396 341.8,396  341.8,338.7 362.7,338.7 362.7,372.7 375.5,372.7 375.5,338.7 432.9,338.7 432.9,359.6 398.9,359.6 398.9,372.7 433,372.7 433,430  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.4,341.2v15.9h-29h-5v5v8.1v5h5h29.2v52.3h-15.9v-29v-5h-5h-8.2h-5v5v28.9H344v-15.9h29h5v-5v-7.9v-5h-5h-28.7v-52.3 h15.9v29v5h5h7.8h5v-5v-29H430.4 M435.4,336.2H373v34h-7.8v-34h-25.9v62.3H373v7.9h-34v25.9h62.3v-33.9h8.2v34h25.9v-62.3h-34.2 v-8.1h34V336.2L435.4,336.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(1 0 0 -1 220.1661 53.042)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(0.6304 -0.7763 -0.6397 -0.5194 102.3645 283.8583)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(0.6304 -0.7763 -0.6397 -0.5194 61.6978 218.525)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(0.8457 -0.5336 -0.4397 -0.6969 143.6973 240.4114)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(0.8654 -0.5012 -0.413 -0.713 43.665 133.8584)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(0.9685 -0.2489 -0.2051 -0.7981 85.665 103.6667)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(0.7551 -0.6557 -0.5403 -0.6222 157.9756 188.2109)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(0.8258 -0.5639 -0.4647 -0.6805 160.5623 127.5798)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(0.9091 -0.4166 -0.3433 -0.7491 174.4013 79.9221)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(-0.2565 -0.9666 0.8822 -0.2341 369.0973 210.3612)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(-0.6304 -0.7763 0.6397 -0.5194 306.5139 268.8007)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(-0.7891 -0.6143 0.5062 -0.6502 319.915 175.885)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(-0.6931 -0.7208 0.5939 -0.5711 272.0764 230.0708)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(-0.4924 -0.8704 0.7172 -0.4057 390.3991 152.0174)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(-0.9527 -0.3039 0.2504 -0.785 352.9767 102.1091)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(-0.7551 -0.6557 0.5403 -0.6222 270.0765 166.6304)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(-0.7803 -0.6254 0.5153 -0.643 270.9725 116.0023)",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leaf",
    width: 41,
    height: 94.1,
    x: -20.5,
    y: -47,
    transform: "matrix(-0.8193 -0.5734 0.4725 -0.6751 269.9725 64.2137)",
    style: {
      overflow: "visible"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M247.8,94c-11.6,10.2-18.9,26.2-23.1,40.8c-2.2,7.6-3.3,15.5-3.7,23.4c-0.3,6.1-0.7,16.2,4.4,20.6c0.7,0.6,2,0.5,2.6-0.1 c0.6-0.6,0.8-1.2,0.7-1.8c0,0,0,0,0,0c-0.6-2.5-2-4.7-2.6-7.2c-1-4.1-0.8-8.6-0.6-12.8c0.3-7.5,1.6-15,3.6-22.3 c4.1-14.7,12.2-26.3,20.6-38.7C250.7,94.6,249,93,247.8,94z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.3,147.9c-0.6-6.4-1.2-12.8-1.8-19.2c-0.6-6.4-1.1-12.9-1.6-19.3c-0.3-3.7,2.8-12.9-1-14.9c0,0-2.1-0.8-2.1-0.8 c-3,2.1-1.5,9.5-1.3,12.6c0.4,6.5,0.9,12.9,1.4,19.3c0.5,6.4,1.1,12.8,1.7,19.2c0.6,6.2,0.2,20.1,1.9,26.1c0.6,2,3.7,2.1,3.8-0.2 C227.5,165.6,226.8,153.1,226.3,147.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.2,171.6c-1.1-2.9-2.9-5.6-4.1-8.6c-1.4-3.5-2.4-7.1-3.7-10.5c-2.4-6.5-5.3-12.7-8.8-18.6c-3.3-5.5-7.2-10.7-11.9-15.2 c-2.5-2.4-7.1-7.5-11-6.1c-1,0.4-0.7,1.8,0.1,2.1c2.3,1,4.7,3.9,6.6,5.6c2.3,2.1,4.3,4.5,6.3,6.9c3.9,4.7,6.9,10.1,9.6,15.6 c2.6,5.2,4.6,10.7,6.5,16.2c1.7,5.1,3.1,11.6,7.6,15C227.1,175.2,228.8,173.3,228.2,171.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.4,205.8c-2.3-11-7.4-20.9-14.9-29.2c-3.5-4-8.2-6.8-11.5-10.9c-1.6-2.1-4.3-0.7-5.8-3.5c-1.1-2.1-3.1-2.4-4.5-4.2 c-1.1-1.4-3.1,0.1-2.5,1.6c0.8,1.8,2.5,2.5,3.4,4.3c0.6,1.3,1.2,2.5,2.4,3.4c1.6,1.1,3.3,1.1,4.8,2.8c2,2.3,4.7,4.1,6.9,6.2 c8.7,8.1,14.5,18.9,16.9,30.5C214.4,209.6,219,208.8,218.4,205.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.1,237.9c-5.3-4.5-10.6-9.1-16-13.5c-4.6-3.9-9.2-8.6-14.7-11.2c-0.9-0.4-2,0.8-1.4,1.6c3,4.7,7.9,8.3,12.1,12 c5.7,5,11.5,10,17.3,15C210.7,243.7,213.4,239.8,211.1,237.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M208.4,306.9c-1.9-4-2.5-4.6-6.2-6.8c-5.1-3.1-9.9-6.5-14.7-9.9c-4.3-3.1-8.5-6.5-12.5-9.9c-4-3.4-13.6-16.3-13.6-9.1 c1.1,4.5,5,7.3,8.3,10.2c3.5,3.3,7.2,6.3,11,9.3c4.2,3.3,8.5,6.4,12.9,9.4c4.7,3.2,9.9,5.3,12.4,10.6 C207.2,313.4,209.7,309.6,208.4,306.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.3,340.2c-12.9-4-25.5-8.2-37.7-14c-12.5-5.9-26-14.1-37.4-21.7c-0.5-0.3,1.5-0.1,1,0.2c0.2-0.1-0.7,0.3-0.8,0.5 c0,0.2-0.1,0.3-0.1,0.5c-0.3,0.8-2.8,1.2-2.1,1.7c20.4,17.6,49.5,30.7,75.7,37.1C207.5,345.2,209.1,341.1,206.3,340.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M278.8,288.6c-22.7,6.8-35.3,22.7-50.8,39.3c-1.9,2,0.9,5.4,2.8,3.3c7.7-8.3,12.3-15.1,20.4-23c8-7.9,18.5-11.8,28.8-16 C281.9,291.4,280.8,288,278.8,288.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M334.7,219.3c-1.6-2.7-4.7-2.5-7.5-2.9c-5-0.8-10.1-1.4-15.2-1.8c-2.3-0.2-19.6-1.2-14.7,5.5c0.5,0.6,1.3,0.9,2,0.7 c1.2-0.2,5-1.9,5.4-2.8c2.3,0,5.5,0.7,7,0.7c3.2,0.2,6.4,0.5,9.5,0.7c3.9,0.3,8,5.2,13.5,0C334.7,219.4,334.8,219.4,334.7,219.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M359.3,164.1c-3.5,2.4-7.1,4.7-10.8,6.8c-3.1,1.8-6.5,3.3-9.3,5.5c-1.4,1.1-0.3,3.7,1.5,3.2c7.5-2.3,14.7-8.2,21-12.8 C363.6,165.4,361.3,162.8,359.3,164.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M243.6,253.3c-7.3,3-13.3,9.7-17.3,16.3c-0.5,0.8-0.5,1.8,0.1,2.5c0.4,0.5,0.7,0.6,1.4,0.7c0.7,0.1,1.5-0.3,1.8-0.9 c4-6.9,9.3-11.4,15.6-16.1C246.7,254.7,245.1,252.7,243.6,253.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M246.6,190.8c-3.6,0.1-9.8,3.9-12.2,6.6c-3.1,3.6-5.9,8-8.1,12.2c-1.1,2.1,1.5,4.1,3.1,2.1c4.4-5.5,11.1-15.8,19-17 C250.3,194.4,248.6,190.8,246.6,190.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M247.3,142.3c-18.7,2.1-20.8,19.9-23,28.1c-0.6,2.4,3,3.7,3.6,1.3c1-3.7,4-17.5,6.8-20.1c3.2-3,11.5-4.6,15.5-5.7 C251.7,145.4,249,142.1,247.3,142.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M336.2,137.7c-4.6,2.1-11.4,9.1-14.5,13c-1.7,2.1,4.6,1.3,6.2-0.8c3-3.7,6.3-6.6,9.8-9.8C339,139,337.7,137,336.2,137.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M340.9,135.4c-1.2-0.1-2,0.5-3.1,1.2c-1.1,0.7-2.2,1.4-3.2,2.1c-1.4,1.1,0.1,3,1.6,2.4c1.1-0.4,2.1-0.9,3.2-1.4 c1-0.5,2.1-0.9,2.7-1.9C342.6,136.9,342.2,135.5,340.9,135.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M130.7,209c-3.3-4.4-8.4-7.6-11.9-12c-4.1-5.1-7.2-10.9-9.5-17c-2-5.3-2.6-10.6-6.3-15.1c-2.6-3.2-3.7-7.3-5.2-11.1 c-1.5-4-2.1-9.7-1.5-14c0.3-2-4.2-2.6-4.8-0.7c-1.9,6.2,1.6,14.5,3.7,20.3c1.5,4.2,3.6,6.9,5.9,10.7c1.9,3,2.3,7.1,3.4,10.5 c2.3,6.6,5.5,12.6,9.6,18.3c3.5,4.7,8.7,11.2,14.3,13.3C130.4,212.9,131.8,210.5,130.7,209z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5,215.8c-1.1-5.8-8.1-5.7-12.3-8.1c-6.1-3.5-10-10.5-15.2-15.2c-5.4-4.8-11.4-8.6-18.1-11.3c-4-1.7-6.9-3.7-9.7-7 c-2.1-2.4-2-8.3-4.8-10c-0.9-0.5-2.2,0.1-1.9,1.3c1.3,4.9,4.3,12.7,8,16.1c2.3,2.1,5.5,3.2,8.3,4.5c3.7,1.7,7.2,3.9,10.5,6.3 c5.9,4.2,10,10,15,15.2c2,2.1,4.3,4,6.9,5.3c2.7,1.3,10.6,4.9,11.9,7.9C122.2,223,122.9,218.3,122.5,215.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M145.7,262.3c-11-0.9-21.7-3-32-6.6c-5-1.7-9.8-3.9-14.5-6.2c-2.5-1.2-4.8-4.2-6.8-6.1c-1.4-1.4-1.6-1.3-3.2-2.4 c-0.5-0.3-1.1-0.2-1.4,0.3c-0.3,0.4-0.6,0.9-1,1.3c0,0.1,0,0.1,0.1,0.1c0.2,0,0.3,0,0.5,0c-0.8,7.4,15.3,13.1,20,15.2 c12,5.2,25,8.2,38.1,9.2C148.4,267.2,148.7,262.5,145.7,262.3z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 163.7,
    cy: 353.7,
    rx: 17.7,
    ry: 48
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 258.8,
    cy: 336.2,
    rx: 17.7,
    ry: 48
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M151.8,329.9c-0.9-1.1-2.5-2-4-2c-1.6,0-3,0.3-4.2,1.4c-1.2,1-1.9,2.5-2,4c-0.1,1.5,0.4,3,1.4,4.2c0.9,1.1,2.5,2,4,2 c1.6,0,3-0.3,4.2-1.4c1.2-1,1.9-2.5,2-4C153.2,332.6,152.8,331.1,151.8,329.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.9,346.2c-0.6-2.4-2-4.2-4.4-5.2c-1-0.4-2.4-0.5-3.5-0.2c-0.6,0.1-1.1,0.3-1.6,0.5c-1.4,0.8-1.5,1-2.5,2.1 c-0.7,0.9-1,2-1.1,3.1c-0.1,1.1,0.1,2.1,0.6,3.1c0.5,1,1.2,1.8,2.1,2.4c0.1,0.1,0.2,0.2,0.4,0.2c1.4,1,3.3,1.5,5,1.2 C151.2,353,153.7,349.6,152.9,346.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M146.2,360.9c-4.4,0-4.9,6.8-0.5,6.8C150.1,367.7,150.6,360.9,146.2,360.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M148.3,375.1c-1.2,0-2.3,0.3-3.3,1.1c-0.9,0.8-1.5,1.9-1.6,3.2c-0.2,2.4,1.7,4.9,4.2,4.9c1.2,0,2.3-0.3,3.3-1.1 c0.9-0.8,1.5-1.9,1.6-3.2C152.7,377.6,150.8,375.1,148.3,375.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.2,362.9c-1-1.2-2.8-2.2-4.4-2.2c-1.7,0-3.2,0.4-4.6,1.5c-1.3,1.1-2.1,2.7-2.2,4.4c-0.1,1.6,0.4,3.3,1.5,4.6 c1,1.2,2.8,2.2,4.4,2.2c1.7,0,3.2-0.4,4.6-1.5c1.3-1.1,2.1-2.7,2.2-4.4C151.8,365.8,151.3,364.1,150.2,362.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157.6,390.5c-5,0-5.6,7.7-0.5,7.7C162,398.2,162.6,390.5,157.6,390.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M169.6,393.6c-0.1,0-0.2-0.1-0.3-0.1c-3.6-1.4-7.6,1.4-7.9,5.1c-0.1,2.1,0.8,4.1,2.5,5.3c0.9,0.6,1.9,1,3,1 c1,0.1,2-0.1,3-0.6c0.1,0,0.2-0.1,0.3-0.1c1.9-0.7,3.1-2.9,3.3-4.8C173.6,396.8,172,394.5,169.6,393.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M178.8,385.9c-0.8-0.9-2.1-1.7-3.4-1.7c-1.3,0-2.5,0.3-3.5,1.1c-1,0.8-1.6,2.1-1.7,3.4c-0.1,1.3,0.3,2.5,1.1,3.5 c0.8,0.9,2.1,1.7,3.4,1.7c1.3,0,2.5-0.3,3.5-1.1c1-0.8,1.6-2.1,1.7-3.4C180,388.1,179.6,386.9,178.8,385.9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M183,372.6c-0.8-0.9-2.1-1.7-3.3-1.7c-1.3,0-2.4,0.3-3.4,1.1c-1,0.8-1.6,2-1.7,3.3c-0.1,1.2,0.3,2.5,1.1,3.4 c0.8,0.9,2.1,1.7,3.3,1.7c1.3,0,2.4-0.3,3.4-1.1c1-0.8,1.6-2,1.7-3.3C184.2,374.8,183.8,373.5,183,372.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M181.7,352.6c-7.4,0-8.2,11.5-0.8,11.5C188.3,364.1,189.2,352.6,181.7,352.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M182.2,342.1c-1.2,0-2.3,0.8-2.4,2.1c-0.1,1.2,0.9,2.4,2.1,2.4c1.2,0,2.3-0.8,2.4-2.1C184.3,343.3,183.4,342.1,182.2,342.1z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5,323.1c-0.3-0.5-0.6-0.9-0.9-1.3c-0.7-0.8-1.5-1.4-2.5-1.7c-1.4-0.5-3-0.4-4.4,0.2c-0.9,0.4-1.7,1.1-2.3,1.9 c-0.8,1.2-1.4,3-0.9,4.4c0.4,1.3,0.5,1.6,1.3,2.8c0.3,0.5,0.7,0.8,1.2,1.1c1.3,0.8,2.8,1.2,4.3,0.9c1.5-0.3,2.7-1.1,3.6-2.3 c0.6-0.8,1.1-2.1,1.1-3.1C184.1,325,183.9,324,183.5,323.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M168.3,301.4c-0.8-0.9-2.1-1.7-3.3-1.7h-0.5c-1.3,0-2.4,0.3-3.4,1.1c-1,0.8-1.6,2-1.7,3.3c-0.1,1.2,0.3,2.5,1.1,3.4 c0.8,0.9,2.1,1.7,3.3,1.7h0.5c1.3,0,2.4-0.3,3.4-1.1c1-0.8,1.6-2,1.7-3.3C169.5,303.6,169.1,302.4,168.3,301.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M156.2,316.6c-0.1-0.5-0.2-1.1-0.5-1.6c-0.6-1.3-1.7-2.3-3.1-2.8c-2.3-0.8-4.9,0-6.2,2c-1.4,2-1.3,4.7,0.3,6.6 c0.6,0.7,1.4,1.3,2.3,1.6c1.2,0.4,2.9,0.5,4.1-0.2c0.9-0.5,1.5-0.9,2.1-1.8C156.1,319.3,156.5,317.9,156.2,316.6z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M184.1,340.7c0,0-0.1-0.1-0.1-0.1c-1.2-1-3.2-1.1-4.6-0.4c-0.1,0.1-0.3,0.1-0.4,0.2c-1.4,0.7-2.3,2-2.5,3.6 c-0.1,0.8,0.1,1.5,0.4,2.2c0.5,1.1,1.4,1.7,2.5,2.2c0.1,0.1,0.3,0.1,0.4,0.2c1.4,0.7,3.3,0.1,4.5-0.8c0,0,0.1-0.1,0.1-0.1 c0.9-0.8,1.5-1.9,1.6-3.1C186.1,343,185.4,341.7,184.1,340.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M247.6,327.6c-0.9-1.1-2.5-2-4-2c-1.6,0-3,0.3-4.2,1.4c-1.2,1-1.9,2.5-2,4c-0.1,1.5,0.4,3,1.4,4.2c0.9,1.1,2.5,2,4,2 c1.6,0,3-0.3,4.2-1.4c1.2-1,1.9-2.5,2-4C249.1,330.3,248.6,328.8,247.6,327.6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M242,352.6c-0.5,0-0.6,0.8-0.1,0.8C242.5,353.4,242.5,352.6,242,352.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M249.6,351.6c-1.8-1.3-4.3-1.5-6.3-0.5s-3.4,3-3.5,5.2c-0.1,1.8,0.5,3.5,1.7,4.7c0.2,0.2,0.4,0.4,0.6,0.6c0,0,0,0,0.1,0.1 c0.1,0.1,0.2,0.2,0.3,0.3c1.8,1.3,4.1,1.4,6.1,0.5c2-0.9,3.5-3.1,3.6-5.3C252.3,355,251.4,352.9,249.6,351.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M246.7,370.3C246.6,370.3,246.6,370.4,246.7,370.3C246.7,370.4,246.7,370.3,246.7,370.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M252.7,368.1c-0.9-1-2.3-1.9-3.7-1.9c-1.4,0-2.7,0.3-3.9,1.3c-1.1,0.9-1.8,2.3-1.9,3.7c-0.1,1.4,0.4,2.8,1.3,3.9 c0.9,1,2.3,1.9,3.7,1.9c1.4,0,2.7-0.3,3.9-1.3c1.1-0.9,1.8-2.3,1.9-3.7C254,370.6,253.6,369.2,252.7,368.1z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M254.6,382c-0.3,0-0.5,0-0.8,0c-0.4,0.1-0.8,0.5-0.8,0.9c0,0.6,0.4,0.9,0.9,1c0.3,0,0.5,0.1,0.8,0c0.4-0.1,0.8-0.5,0.8-0.9 C255.5,382.5,255.1,382.1,254.6,382z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M261.9,379.1c-1-1.2-2.6-2.1-4.2-2.1c-1.6,0-3.1,0.3-4.3,1.4c-1.2,1-2,2.6-2.1,4.2c-0.1,1.6,0.4,3.1,1.4,4.3 c1,1.2,2.6,2.1,4.2,2.1c1.6,0,3.1-0.3,4.3-1.4c1.2-1,2-2.6,2.1-4.2C263.4,381.8,262.9,380.3,261.9,379.1z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M266.3,373.3c-0.1,0-0.1,0-0.2-0.1c-0.9-0.4-2.1-0.1-2.8,0.5c-1,0.9-1.2,2.2-0.7,3.4c0,0.1,0,0.1,0.1,0.2 c0.7,1.8,3.2,2.2,4.6,1C269,376.8,268.4,374.1,266.3,373.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M273.6,356.7c-1.2,0-2.2,0.2-3.1,1c-0.9,0.7-1.4,1.8-1.5,3c-0.2,2.2,1.7,4.6,4,4.6c1.2,0,2.2-0.2,3.1-1 c0.9-0.7,1.4-1.8,1.5-3C277.8,359.1,276,356.7,273.6,356.7z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M275,346.5c-0.1,0-0.2,0.1-0.3,0.1c-1,0.1-1.9,1.2-1.3,2.3c0.3,0.6,0.7,0.8,1.2,1.1c0.8,0.4,1.7-0.1,2.2-0.7 C277.8,348.1,276.4,346.1,275,346.5z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M275.4,336.9c-1,0-1.1,1.5-0.1,1.5C276.2,338.4,276.3,336.9,275.4,336.9z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M274,320c-0.4,0-0.4,0.6,0,0.6C274.4,320.6,274.4,320,274,320z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M278.8,334.2c-0.9-1-2.3-1.9-3.7-1.9c-1.4,0-2.7,0.3-3.9,1.3c-1.1,0.9-1.8,2.3-1.9,3.7c-0.1,1.4,0.4,2.8,1.3,3.9 c0.9,1,2.3,1.9,3.7,1.9c1.4,0,2.7-0.3,3.9-1.3c1.1-0.9,1.8-2.3,1.9-3.7C280.1,336.7,279.7,335.3,278.8,334.2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M277.6,320.8c-1-1.2-2.8-2.3-4.5-2.3c-1.7,0-3.3,0.4-4.6,1.5c-1.3,1.1-2.1,2.7-2.3,4.5c-0.1,1.7,0.4,3.3,1.5,4.6 c1,1.2,2.8,2.3,4.5,2.3c1.7,0,3.3-0.4,4.6-1.5c1.3-1.1,2.1-2.7,2.3-4.5C279.2,323.8,278.7,322.1,277.6,320.8z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M274.4,306.5c-0.8-1-2.2-1.8-3.6-1.8c-1.4,0-2.6,0.3-3.7,1.2c-1.1,0.9-1.7,2.2-1.8,3.6c-0.1,1.3,0.3,2.7,1.2,3.7 c0.8,1,2.2,1.8,3.6,1.8c1.4,0,2.6-0.3,3.7-1.2c1.1-0.9,1.7-2.2,1.8-3.6C275.7,308.8,275.3,307.5,274.4,306.5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M265.7,290.9c-7,0-7.8,10.9-0.8,10.9C271.9,301.8,272.8,290.9,265.7,290.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5,286.1c-2-1.4-4.4-1.1-6.2,0.3c-1.1,0.8-1.9,2.4-1.9,3.7c0,1.3,0.3,2.4,1.1,3.4c0.3,0.3,0.6,0.6,0.9,0.8 c0.8,0.6,1.8,1.1,2.8,1.1c2.3,0.2,4.4-1.2,5.2-3.4C262.1,289.9,261.3,287.4,259.5,286.1z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M250.1,297c-1.1-0.8-2.8-1-4.1-0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-1.2,0.7-2.1,1.7-2.2,3.2c-0.1,1.3,0.5,2.8,1.6,3.4 c0.1,0.1,0.2,0.1,0.3,0.2c1.3,0.7,2.7,1,4.1,0.3c1.3-0.6,2.2-1.9,2.3-3.4C251.9,299.2,251.3,297.8,250.1,297z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M247,307c-1-1.2-2.5-1.6-4-1.4c-0.1,0-0.2,0-0.4,0c-1.8,0.2-3.2,2-3.4,3.8c-0.1,1.1,0.3,2.2,1,3c0.8,0.9,1.7,1.3,2.9,1.5 c0.1,0,0.3,0,0.4,0.1c2.3,0.3,4.3-1.7,4.5-3.9C248.1,308.9,247.7,307.8,247,307z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M245.1,316.5c-0.5-0.2-1-0.4-1.6-0.4c-1.3-0.1-2.3,0.4-3.3,1.2c-0.8,0.6-1.3,1.8-1.4,2.8c-0.1,1.4,0.6,2.8,1.7,3.6 c0.7,0.5,1.5,0.9,2.4,0.9c0.9,0.1,1.8-0.2,2.6-0.6c1.3-0.6,2.2-1.9,2.3-3.3C247.9,318.7,246.8,317.3,245.1,316.5z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M243.7,339.3c-6.5,0-7.3,10.1-0.7,10.1C249.5,349.4,250.3,339.3,243.7,339.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M267,369.9c-1.7-0.1-3.3,0.7-4.3,2c-1,1.5-1,3.2-0.4,4.8c0,0,0,0.1,0.1,0.1c0.6,1.5,2.4,2.6,3.9,2.7c2.1,0.2,4-1.2,4.8-3.1 c0,0,0-0.1,0.1-0.1C272.3,373.3,270,370.1,267,369.9z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M276.4,356.3c-1.5-1.8-4.1-2.4-6.2-1.3c-0.8,0.4-1.5,1-2,1.7c-0.8,1.2-1,2.5-0.8,4c0,0,0,0.1,0,0.1c0.2,1.7,1.7,3.3,3.3,3.8 c0,0,0.1,0,0.1,0c2.2,0.7,4.7,0,6-1.9C278,360.7,277.9,358.1,276.4,356.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M279.2,346.4c-0.9-1-2.2-1.7-3.5-1.8c-3.3-0.2-6,2.8-5.4,6.1c0.3,1.5,1,2.7,2.2,3.6c0.7,0.5,1.6,0.8,2.5,0.9 c1.4,0.1,2.5-0.4,3.5-1.2c0.7-0.5,1.3-1.4,1.6-2.2c0.2-0.5,0.2-1.1,0.3-1.7C280.7,348.8,280,347.3,279.2,346.4z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M174.2,312.3c-0.1,0-0.2,0.1-0.3,0.1c-0.7,0.3-1.1,1-1.2,1.8c-0.1,1,0.5,1.8,1.4,2.1c0.1,0,0.2,0.1,0.3,0.1 c1.4,0.6,2.9-0.6,3-2C177.5,312.7,175.7,311.7,174.2,312.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M175.9,309.7c-1,0-1.9,0.2-2.7,0.9c-0.8,0.7-1.3,1.6-1.3,2.6c-0.1,2,1.5,4.1,3.5,4.1c1,0,1.9-0.2,2.7-0.9 c0.8-0.7,1.3-1.6,1.3-2.6C179.6,311.8,178,309.7,175.9,309.7z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M156.1,386.2c-0.9-1-2.3-1.9-3.7-1.9c-1.4,0-2.7,0.3-3.8,1.3c-1.1,0.9-1.8,2.3-1.9,3.7c-0.1,1.4,0.4,2.8,1.3,3.8 c0.9,1,2.3,1.9,3.7,1.9c1.4,0,2.7-0.3,3.8-1.3c1.1-0.9,1.8-2.3,1.9-3.7C157.4,388.7,157,387.3,156.1,386.2z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M154.9,397c-1.8,0-3.4,1.2-3.5,3c-0.1,1.7,1.3,3.5,3,3.5c1.8,0,3.4-1.2,3.5-3C158.1,398.8,156.7,397,154.9,397z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBihar);
export default __webpack_public_path__ + "static/media/bihar.aca41ff0b9646f74381f0572110ab7a0.svg";
export { ForwardRef as ReactComponent };